module.exports = ".name {\n  font-weight: bold;\n  margin-right: 20px; }\n\n.size {\n  font-size: 9px; }\n\n.remove {\n  margin-left: auto; }\n\n.file {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  line-height: 48px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/file-upload/file-upload.component.scss
// module id = ./src/app/file-upload/file-upload.component.scss
// module chunks = main